import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject, takeUntil } from "rxjs";
import { selectCheckInfo } from "../../../../../create-request/reducers";
import { CheckInfo } from "../../../../../create-request/models/check/CheckInfo";
import { transactionTypes } from "projects/money-movement-ui/src/app/shared/utilities/Constants";
import { selectIsPtrs } from "projects/money-movement-ui/src/app/account-info-header/reducers";

@Component({
  standalone: false,
    selector: 'mm-transaction-review-check',
    templateUrl: './transaction-review-check.component.html',
    styleUrls: ['./transaction-review-check.component.scss']
})

export class TransactionReviewCheckComponent implements OnInit, OnDestroy {
    readonly subtitle: string = 'From account details';
    readonly check: string = transactionTypes.check;
    @Input() isInitiateAndReleaseFlowFromTable: boolean;
    isIraTransaction: boolean;
    isPtrsTransaction: boolean;

    destroy$: Subject<void> = new Subject<void>();
    
    constructor(private store: Store) {}

    ngOnInit(): void {
        this.store.select(selectCheckInfo).pipe(takeUntil(this.destroy$)).subscribe((info: CheckInfo) => {
            this.isIraTransaction = info.iraAccount;
        })

        this.store.select(selectIsPtrs).pipe(takeUntil(this.destroy$)).subscribe(value => {
            this.isPtrsTransaction = value;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}